<template>
  <PageTabs
    :tabConfig="tabConfig"
  >
    <router-view />
  </PageTabs>
</template>

<script>
import PageTabs from 'client/components/PageLayouts/PageTabs.vue';

export default {
  name: 'SettingsPage',

  components: {
    PageTabs,
  },

  computed: {
    tabConfig() {
      const config = [
        {
          name: 'Organization Profile',
          label: 'Organization Profile',
        },
        {
          name: 'Security Settings',
          label: 'Security',
        },
        {
          name: 'Administrator Settings',
          label: 'Administrators',
        },
        {
          name: 'Customize Email',
          label: 'Customize Email',
        },
        {
          name: 'Feature Settings',
          label: 'Features',
        },
      ];

      return config;
    },
  },
};
</script>
